import type { ComponentCommonMedia } from '@edwin-group/cj-graphql/generated/graphql';
import { useResponsiveImage } from '@/utils/useResponsiveImage';
import classNames from 'classnames';

export default function DefaultContentTemplateMedia({
  component,
  className,
  arrowImg,
  isDefaultContentTemplate = false,
}: {
  component: ComponentCommonMedia;
  className?: string;
  arrowImg?: string;
  isDefaultContentTemplate?: boolean;
}) {
  const { src } = useResponsiveImage(component!.media);

  return (
    <div
      className={classNames(className, {
        'my-0': isDefaultContentTemplate,
        'my-sh-60': !isDefaultContentTemplate,
      })}
      key={component.id}>
      <div style={{ paddingTop: '56.25%', position: 'relative' }}>
        {arrowImg && (
          <img src={arrowImg} alt="arrow cover" className="absolute bottom-0 right-10 z-50 translate-y-1/2" />
        )}
        <img
          alt="Media common component"
          src={src}
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          className="z-40 h-auto w-full rounded-2xl object-cover"
        />
      </div>
    </div>
  );
}
